<div nz-row [nzGutter]="[56, 56]">
  <div nz-col [nzLg]="5" style="box-shadow: 5px 0px 3px 0px #00000017">
    <nz-steps [nzCurrent]="currentStep" nzDirection="vertical">
      <nz-step [nzTitle]="'Define your filter' | locale"></nz-step>
      <nz-step [nzTitle]="'Participants selection' | locale"></nz-step>
      <nz-step [nzTitle]="'Campaign configurations' | locale">
      </nz-step>
    </nz-steps>
  </div>
  <div nz-col [nzLg]="19">
    <nz-space nzDirection="vertical" style="width: 100%">
      <nz-space-item>
        <nz-button-group style="float: right">
          <button nz-button nzType="default" (click)="pervStep()" [disabled]="currentStep == 0"><i nz-icon nzType="left"
              nzTheme="outline"></i>{{'Previous' | locale }}</button>
          <button nz-button nzType="default" (click)="nextStep()" *ngIf="currentStep < maxStepCount -1"
            [disabled]="currentStep == maxStepCount">{{'Next' | locale }}<i nz-icon nzType="right"
              nzTheme="outline"></i></button>
          <button nz-button nzType="primary" (click)="nextStep()" *ngIf="currentStep == maxStepCount -1"
            [disabled]="currentStep == maxStepCount">{{'Finish' | locale }}</button>
        </nz-button-group>
      </nz-space-item>
      <nz-space-item>
        <div class="steps-content">
          <!--Define your filter-->
          <div nz-form *ngIf="currentStep == 0">
            <div>
              <button type="button" *ngIf="selectedFilter === ''" class="btn btn-default txt-color-red pull-right"
                (click)="loadFilter('','');">
                <i class="fa fa-eraser"></i> {{'Clear filters'|locale}}
              </button>
              <div class="btn-group pull-right" *ngIf="selectedFilter !== ''">
                <button type="button" class="btn btn-default txt-color-red pull-right" (click)="loadFilter('','');">
                  <i class="fa fa-eraser"></i> {{'Clear selection'|locale}}
                </button>
                <button type="button" data-toggle="modal" data-target="#UpdatingFilterModal"
                  class="btn btn-default txt-color-green pull-right">
                  <i class="fa fa-save"></i> Update ({{filterName}})
                </button>
                <button type="button" (click)="deleteFilter(selectedFilter)"
                  class="btn btn-default txt-color-red pull-right">
                  <i class="icon-bweb-delete"></i> Delete ({{filterName}})
                </button>
              </div>
              <div class="btn-group pull-right" style="margin-right: 8px;">
                <button type="button" class="btn btn-default txt-color-orangeDark" data-toggle="modal"
                  data-target="#SavingFilterModal">
                  <i class="glyphicon glyphicon-asterisk"></i> {{'Save new filter'|locale}}
                </button>
              </div>
              <button nz-button nz-dropdown [nzDropdownMenu]="filtersMenu">
                {{ 'Select predefined filter' | locale }} &nbsp;
                <i class="fas fa-caret-down"></i>
              </button>
              <nz-dropdown-menu #filtersMenu="nzDropdownMenu">
                <ul nz-menu>
                  <span *ngFor="let filter of savedFilterList">
                    <li nz-menu-item>
                      <a (click)="loadFilter(filter.Code,filter.Name);">{{
                        filter.Name
                        }}</a>
                    </li>
                  </span>
                </ul>
              </nz-dropdown-menu>
            </div>
            <div class="item-info-criteria well">
              <fieldset>
                <legend>Item Data</legend>
                <div *ngFor="let orList of filterObject.ItemInfo;let parentIndex=index;" class="sub-filter well">
                  <div *ngIf="parentIndex != 0" class="or-block">Or</div>
                  <a (click)="removeOrList('item',parentIndex)" class="delete-or-button">
                    <i class="fa fa-times txt-color-red"></i>
                  </a>
                  <div *ngFor="let subFilter of orList ;let indexOfelement=index;" class="row and-block">
                    <div class="col-md-3 filter-field">
                      <nz-select nzShowSearch [(ngModel)]="subFilter.FieldId" (ngModelChange)="changeFilterType(subFilter)" [ngModelOptions]="{standalone: true}">
                        <ng-container *ngFor="let field of itemFilterFields">
                          <nz-option [nzValue]="field.Id" [nzLabel]="field.Label">
                          </nz-option>
                        </ng-container>
                      </nz-select>
                    </div>
                    <div class="col-md-2 condition-field">
                      <nz-select nzShowSearch [(ngModel)]="subFilter.FilterOpr" [ngModelOptions]="{standalone: true}">
                        <ng-container *ngFor="let operation of compareOperations">
                          <nz-option [nzValue]="operation.Code" [nzLabel]="operation.Title">
                          </nz-option>
                        </ng-container>
                      </nz-select>
                    </div>
                    <div class="col-md-3">
                      <input type="text" class="form-control" *ngIf="subFilter.DataType == 1"
                        [(ngModel)]="subFilter.FieldValue" />
                      <input type="number" class="form-control" *ngIf="subFilter.DataType == 2"
                        [(ngModel)]="subFilter.FieldValue" />
                      <input type="date" class="form-control" *ngIf="subFilter.DataType == 3"
                        [(ngModel)]="subFilter.FieldValue" />

                      <div *ngIf="subFilter.DataType == 4">
                        <nz-select nzShowSearch [(ngModel)]="subFilter.FieldValue">
                          <ng-container *ngFor="let option of subFilter.Options">
                            <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                            </nz-option>
                          </ng-container>
                        </nz-select>
                      </div>

                      <div *ngIf="subFilter.DataType == 5">
                        <nz-select nzMode="multiple" nzShowSearch [(ngModel)]="subFilter.FieldValue"
                           >
                          <ng-container *ngFor="let option of subFilter.Options">
                            <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                            </nz-option>
                          </ng-container>
                        </nz-select>
                      </div>
                    </div>
                    <div class="col-md-3 text-left" *ngIf="subFilter.FilterOpr == 'BET'">
                      <div class="pull-left" style="width: 15%; padding-top: 5px;">
                        And
                      </div>
                      <div class="pull-right" style="width: 85%;">
                        <input type="text" class="form-control" *ngIf="subFilter.DataType == 1"
                          [(ngModel)]="subFilter.FieldValueTo" [ngModelOptions]="{standalone: true}" />
                        <input type="number" class="form-control" *ngIf="subFilter.DataType == 2"
                          [(ngModel)]="subFilter.FieldValueTo" [ngModelOptions]="{standalone: true}" />
                        <input type="date" class="form-control" *ngIf="subFilter.DataType == 3"
                          [(ngModel)]="subFilter.FieldValueTo" [ngModelOptions]="{standalone: true}" />

                        <div *ngIf="subFilter.DataType == 4">
                          <nz-select nzShowSearch [(ngModel)]="subFilter.FieldValueTo"
                            [ngModelOptions]="{standalone: true}">
                            <ng-container *ngFor="let option of subFilter.Options">
                              <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                              </nz-option>
                            </ng-container>
                          </nz-select>
                        </div>

                        <div *ngIf="subFilter.DataType == 5">
                          <nz-select nzMode="multiple" nzShowSearch [(ngModel)]="subFilter.FieldValueTo"
                            [ngModelOptions]="{standalone: true}">
                            <ng-container *ngFor="let option of subFilter.Options">
                              <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                              </nz-option>
                            </ng-container>
                          </nz-select>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-1 pull-right filter-or-delete-button">
                      <div class="btn-group">
                        <a class="btn btn-default" (click)="removeCondition('item', parentIndex ,indexOfelement)"
                          [ngClass]="{'disabled': !(indexOfelement != 0 || orList.length > 1)}">
                          <i class="fa fa-times txt-color-red"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="add-new-block" (click)="addAndList('item', parentIndex)">
                    <i class="fa fa-plus"></i> Add new condition
                  </div>
                </div>
                <div class="add-or-button-container">
                  <button (click)="addOrList('item')" class="btn btn-default">
                    <i class="fa fa-plus">
                    </i> Or condition
                  </button>
                </div>
              </fieldset>
            </div>
            <div class="bp-info-criteria well">
              <fieldset>
                <legend>BP Master Data</legend>
                <div *ngFor="let orList of filterObject.BPInfo;let parentIndex=index;" class="sub-filter well">
                  <div *ngIf="parentIndex != 0" class="or-block">Or</div>
                  <a (click)="removeOrList('bp',parentIndex)" class="delete-or-button">
                    <i class="fa fa-times txt-color-red"></i>
                  </a>
                  <div *ngFor="let subFilter of orList ;let indexOfelement=index;" class="row and-block">
                    <div class="col-md-3 filter-field">
                      <nz-select nzShowSearch [(ngModel)]="subFilter.FieldId" (ngModelChange)="changeFilterType(subFilter)" [ngModelOptions]="{standalone: true}">
                        <ng-container *ngFor="let field of bpFilterFields">
                          <nz-option [nzValue]="field.Id" [nzLabel]="field.Label">
                          </nz-option>
                        </ng-container>
                      </nz-select>
                    </div>
                    <div class="col-md-2 condition-field">
                      <nz-select nzShowSearch [(ngModel)]="subFilter.FilterOpr" [ngModelOptions]="{standalone: true}">
                        <ng-container *ngFor="let operation of compareOperations">
                          <nz-option [nzValue]="operation.Code" [nzLabel]="operation.Title">
                          </nz-option>
                        </ng-container>
                      </nz-select>
                    </div>
                    <div class="col-md-3">
                      <input type="text" class="form-control" *ngIf="subFilter.DataType == 1"
                        [(ngModel)]="subFilter.FieldValue" />
                      <input type="number" class="form-control" *ngIf="subFilter.DataType == 2"
                        [(ngModel)]="subFilter.FieldValue" />
                      <input type="date" class="form-control" *ngIf="subFilter.DataType == 3"
                        [(ngModel)]="subFilter.FieldValue" />

                      <div *ngIf="subFilter.DataType == 4">
                        <nz-select nzShowSearch [(ngModel)]="subFilter.FieldValue">
                          <ng-container *ngFor="let option of subFilter.Options">
                            <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                            </nz-option>
                          </ng-container>
                        </nz-select>
                      </div>

                      <div *ngIf="subFilter.DataType == 5">
                        <nz-select nzMode="multiple" nzShowSearch [(ngModel)]="subFilter.FieldValue"
                           >
                          <ng-container *ngFor="let option of subFilter.Options">
                            <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                            </nz-option>
                          </ng-container>
                        </nz-select>
                      </div>
                    </div>
                    <div class="col-md-3 text-left" *ngIf="subFilter.FilterOpr == 'BET'">
                      <div class="pull-left" style="width: 15%; padding-top: 5px;">
                        And
                      </div>
                      <div class="pull-right" style="width: 85%;">
                        <input type="text" class="form-control" *ngIf="subFilter.DataType == 1"
                          [(ngModel)]="subFilter.FieldValueTo" [ngModelOptions]="{standalone: true}" />
                        <input type="number" class="form-control" *ngIf="subFilter.DataType == 2"
                          [(ngModel)]="subFilter.FieldValueTo" [ngModelOptions]="{standalone: true}" />
                        <input type="date" class="form-control" *ngIf="subFilter.DataType == 3"
                          [(ngModel)]="subFilter.FieldValueTo" [ngModelOptions]="{standalone: true}" />

                        <div *ngIf="subFilter.DataType == 4">
                          <nz-select nzShowSearch [(ngModel)]="subFilter.FieldValueTo"
                            [ngModelOptions]="{standalone: true}">
                            <ng-container *ngFor="let option of subFilter.Options">
                              <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                              </nz-option>
                            </ng-container>
                          </nz-select>
                        </div>

                        <div *ngIf="subFilter.DataType == 5">
                          <nz-select nzMode="multiple" nzShowSearch [(ngModel)]="subFilter.FieldValueTo"
                            [ngModelOptions]="{standalone: true}">
                            <ng-container *ngFor="let option of subFilter.Options">
                              <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                              </nz-option>
                            </ng-container>
                          </nz-select>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-1 pull-right filter-or-delete-button">
                      <div class="btn-group">
                        <a class="btn btn-default" (click)="removeCondition('bp', parentIndex ,indexOfelement)"
                          [ngClass]="{'disabled': !(indexOfelement != 0 || orList.length > 1)}">
                          <i class="fa fa-times txt-color-red"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="add-new-block" (click)="addAndList('bp', parentIndex)">
                    <i class="fa fa-plus"></i> Add new condition
                  </div>
                </div>
                <div class="add-or-button-container">
                  <button (click)="addOrList('bp')" class="btn btn-default">
                    <i class="fa fa-plus">
                    </i> Or condition
                  </button>
                </div>
              </fieldset>
            </div>
            <div class="lead-info-criteria well">
              <fieldset>
                <legend>Lead Data</legend>
                <div *ngFor="let orList of filterObject.LeadInfo;let parentIndex=index;" class="sub-filter well">
                  <div *ngIf="parentIndex != 0" class="or-block">Or</div>
                  <a (click)="removeOrList('lead',parentIndex)" class="delete-or-button">
                    <i class="fa fa-times txt-color-red"></i>
                  </a>
                  <div *ngFor="let subFilter of orList ;let indexOfelement=index;" class="row and-block">
                    <div class="col-md-3 filter-field">
                      <nz-select nzShowSearch [(ngModel)]="subFilter.FieldId" (ngModelChange)="changeFilterType(subFilter)" [ngModelOptions]="{standalone: true}">
                        <ng-container *ngFor="let field of leadFilterFields">
                          <nz-option [nzValue]="field.Id" [nzLabel]="field.Label">
                          </nz-option>
                        </ng-container>
                      </nz-select>
                    </div>
                    <div class="col-md-2 condition-field">
                      <nz-select nzShowSearch [(ngModel)]="subFilter.FilterOpr" [ngModelOptions]="{standalone: true}">
                        <ng-container *ngFor="let operation of compareOperations">
                          <nz-option [nzValue]="operation.Code" [nzLabel]="operation.Title">
                          </nz-option>
                        </ng-container>
                      </nz-select>
                    </div>
                    <div class="col-md-3">
                      <input type="text" class="form-control" *ngIf="subFilter.DataType == 1"
                        [(ngModel)]="subFilter.FieldValue" />
                      <input type="number" class="form-control" *ngIf="subFilter.DataType == 2"
                        [(ngModel)]="subFilter.FieldValue" />
                      <input type="date" class="form-control" *ngIf="subFilter.DataType == 3"
                        [(ngModel)]="subFilter.FieldValue" />

                      <div *ngIf="subFilter.DataType == 4">
                        <nz-select nzShowSearch [(ngModel)]="subFilter.FieldValue">
                          <ng-container *ngFor="let option of subFilter.Options">
                            <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                            </nz-option>
                          </ng-container>
                        </nz-select>
                      </div>

                      <div *ngIf="subFilter.DataType == 5">
                        <nz-select nzMode="multiple" nzShowSearch [(ngModel)]="subFilter.FieldValue"
                           >
                          <ng-container *ngFor="let option of subFilter.Options">
                            <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                            </nz-option>
                          </ng-container>
                        </nz-select>
                      </div>
                    </div>
                    <div class="col-md-3 text-left" *ngIf="subFilter.FilterOpr == 'BET'">
                      <div class="pull-left" style="width: 15%; padding-top: 5px;">
                        And
                      </div>
                      <div class="pull-right" style="width: 85%;">
                        <input type="text" class="form-control" *ngIf="subFilter.DataType == 1"
                          [(ngModel)]="subFilter.FieldValueTo" [ngModelOptions]="{standalone: true}" />
                        <input type="number" class="form-control" *ngIf="subFilter.DataType == 2"
                          [(ngModel)]="subFilter.FieldValueTo" [ngModelOptions]="{standalone: true}" />
                        <input type="date" class="form-control" *ngIf="subFilter.DataType == 3"
                          [(ngModel)]="subFilter.FieldValueTo" [ngModelOptions]="{standalone: true}" />

                        <div *ngIf="subFilter.DataType == 4">
                          <nz-select nzShowSearch [(ngModel)]="subFilter.FieldValueTo"
                            [ngModelOptions]="{standalone: true}">
                            <ng-container *ngFor="let option of subFilter.Options">
                              <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                              </nz-option>
                            </ng-container>
                          </nz-select>
                        </div>

                        <div *ngIf="subFilter.DataType == 5">
                          <nz-select nzMode="multiple" nzShowSearch [(ngModel)]="subFilter.FieldValueTo"
                            [ngModelOptions]="{standalone: true}">
                            <ng-container *ngFor="let option of subFilter.Options">
                              <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                              </nz-option>
                            </ng-container>
                          </nz-select>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-1 pull-right filter-or-delete-button">
                      <div class="btn-group">
                        <a class="btn btn-default" (click)="removeCondition('lead', parentIndex ,indexOfelement)"
                          [ngClass]="{'disabled': !(indexOfelement != 0 || orList.length > 1)}">
                          <i class="fa fa-times txt-color-red"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="add-new-block" (click)="addAndList('lead', parentIndex)">
                    <i class="fa fa-plus"></i> Add new condition
                  </div>
                </div>
                <div class="add-or-button-container">
                  <button (click)="addOrList('lead')" class="btn btn-default">
                    <i class="fa fa-plus">
                    </i> Or condition
                  </button>
                </div>
              </fieldset>
            </div>
          </div>
          <!--Participants selection-->
          <form nz-form *ngIf="currentStep == 1">
          </form>

          <!--Campaign configurations-->

          <form nz-form *ngIf="currentStep == 2" nz-row>

          </form>

        </div>
      </nz-space-item>
    </nz-space>
  </div>
</div>
